<template>
  <div class="view-container">
    <div
      v-if="branchData.id != undefined"
      name="CheckoutContainer"
      class="app-container"
    >
      <section name="Branch" :data-id="branchData.id">
        <span class="badge"
          >Click here to select your nearest branch <i class="fa fa-pencil"></i
        ></span>
        <h3>Branch</h3>
        <h5>{{ branchData.name }}</h5>
        <iframe
          width="600"
          height="450"
          frameborder="0"
          style="border: 0"
          :src="branchData.mapURL"
          allowfullscreen
        ></iframe>
        <br />
        <div class="form-group branch-contact">
          <label>Contact no:</label>
          <label class="contact">{{ branchData.contactNo }}</label>
        </div>
        <div class="form-group branch-email">
          <label>Email address:</label>
          <label class="email">{{ branchData.emailAddress }}</label>
        </div>
      </section>
      <section name="Profile" v-if="!$tableNo && !$isTab">
        <button
          v-if="branchData.pickup"
          name="DeliveryOption-Pickup"
          class="btn col-md-5 col-sm-12 col-xs-12 deliver-option"
        >
          <input name="Pickup" type="checkbox" hidden value="" />
          <h3>Pickup at</h3>
          <div name="ProfileContainer">
            <span>{{ branchData.name }}</span>
          </div>
        </button>
        <div
          v-if="branchData.pickup && branchData.delivery"
          class="col-md-2 col-sm-12 col-xs-12"
          style="display: inline-block"
        >
          <h3>OR</h3>
        </div>
        <button
          v-if="branchData.delivery"
          name="DeliveryOption-Delivery"
          class="btn col-md-5 col-sm-12 col-xs-12 deliver-option"
        >
          <input name="Delivery" type="checkbox" hidden />
          <input
            name="DeliveryFee"
            type="number"
            hidden
            :value="branchData.deliveryFee"
          />
          <span class="badge"><i class="fa fa-pencil"></i></span>
          <h3>
            Deliver to<small>
              <br />(fee:
              <span :value="branchData.deliveryFee">{{
                branchData.deliveryFee.toFixed(2)
              }}</span
              >)</small
            >
          </h3>
          <div name="ProfileContainer">
            <span>{{ userData.address }}</span>
            <span>{{ userData.province }}</span>
            <span>{{ userData.country }}</span>
            <span>{{ userData.areaCode }}</span>
            <div class="distance"></div>
            <div class="maxDeliveryDistance"></div>
          </div>
        </button>
        <div
          name="ProfileUpdateContainer"
          class="col-md-12 col-sm-12 col-xs-12 profileUpdateContainer"
        >
          <div>
            <div class="row form-group">
              <label class="col-xs-12 col-md-3 control-label">Address</label>
              <div class="col-xs-12 col-md-9">
                <textarea
                  name="Address"
                  type="text"
                  class="form-control"
                  placeholder="What is the delivery street address"
                  rows="3"
                  v-model="userData.address"
                ></textarea>
              </div>
            </div>
            <div class="row form-group">
              <label class="col-xs-12 col-md-3 control-label">Province</label>
              <div class="col-xs-12 col-md-9">
                <input
                  v-if="userData.province"
                  name="Province"
                  type="text"
                  placeholder="Enter the province or state"
                  class="form-control"
                  v-model="userData.province"
                />
                <input
                  v-else
                  name="Province"
                  type="text"
                  placeholder="Enter the province or state"
                  class="form-control"
                  :value="branchData.province"
                />
              </div>
            </div>
            <div class="row form-group">
              <label class="col-xs-12 col-md-3 control-label">Country</label>
              <div class="col-xs-12 col-md-9">
                <input
                  v-if="userData.country"
                  name="Country"
                  type="text"
                  placeholder="Enter the country"
                  class="form-control"
                  :value="userData.country"
                />
                <input
                  v-else
                  name="Country"
                  type="text"
                  placeholder="Enter the country"
                  class="form-control"
                  :value="branchData.country"
                />
              </div>
            </div>
            <div class="row form-group">
              <label class="col-xs-12 col-md-3 control-label"
                >Zip / Area code</label
              >
              <div class="col-xs-12 col-md-9">
                <input
                  v-if="userData.areaCode"
                  name="AreaCode"
                  type="text"
                  placeholder="Enter the zip / area code"
                  class="form-control"
                  :value="userData.areaCode"
                />
                <input
                  v-else
                  name="AreaCode"
                  type="text"
                  placeholder="Enter the zip / area code"
                  class="form-control"
                  :value="branchData.areaCode"
                />
              </div>
            </div>
            <span class="error-text">The location could not be found.</span>
          </div>
        </div>
        <!-- } -->
      </section>
      <section name="Profile" v-else>
        <h3 v-if="$tableNo > 0">Table No {{ $tableNo }}</h3>
        <h3 v-else>Bar Tab</h3>
      </section>
      <section name="Invoice">
        <h3>Order</h3>
        <div class="invoiceItemsContainer">
          <div
            v-for="item in cartData.products"
            :key="
              item.id +
              '-' +
              item.productModifiers.map((m) => m.choices.map((mo) => mo.name))
            "
            :data-sku="item.SKU"
          >
            <div v-if="item.imageURL" class="img-container">
              <img :src="item.imageURL" />
            </div>
            <div v-else class="img"></div>
            <h5>{{ item.name }}</h5>
            <small class="modifiers">{{
              item.productModifiers
                .map((m) => m.choices.map((mo) => mo.name))
                .join(", ")
            }}</small>
            <small v-if="item.specialInstructions" class="instructions">{{
              item.specialInstructions
            }}</small>
            <small v-else class="instructions hidden"></small>
            <h6
              class="product-price"
              :data-price="item.total / item.quantity"
              :data-tax="item.tax"
            >
              {{
                item.quantity > 1
                  ? item.quantity +
                    " x " +
                    (item.total / item.quantity).toFixed(2)
                  : item.total.toFixed(2)
              }}
            </h6>
          </div>
          <input
            type="text"
            name="cartTotal"
            class="hidden"
            :value="cartData.total"
            hidden
          />
        </div>
      </section>
      <section name="order-schedule">
        <h3>Delivery time</h3>
        <button
          name="order-time"
          class="btn col-md-5 col-sm-12 col-xs-12 selected"
        >
          <input name="order-now" type="checkbox" hidden checked />
          <h3>When ready</h3>
        </button>
        <div class="col-md-2 col-sm-12 col-xs-12"></div>
        <button name="order-time" class="btn col-md-5 col-sm-12 col-xs-12">
          <input name="schedule-order" type="checkbox" hidden />
          <h3>Schedule later</h3>
        </button>

        <div
          name="order-scheduled-datetime-picker-container"
          style="display: none"
        >
          <div class="row justify-content-center form-group">
            <br /><br />
            <div
              class="
                col-lg-8 col-md-8 col-sm-12 col-xs-12
                justify-content-md-center
              "
            >
              <b-form-datepicker
                name="order-scheduled-date-picker"
                class="col-lg-6 col-md-12 col-sm-12 col-xs-12"
                style="margin: auto; margin-top: 15px"
                v-model="selectedDate"
                :min="minDate"
                :max="maxDate"
                locale="en"
              ></b-form-datepicker>
            </div>
            <br />
            <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
              <select
                name="order-scheduled-time-picker"
                class="form-control"
                data-placeholder="Select date"
                style="margin: auto; margin-top: 15px"
              ></select>
            </div>
          </div>
        </div>
      </section>
      <section name="Gratuity">
        <h3>Gratuity</h3>
        <input
          type="number"
          class="isNumber text-center"
          step="0.01"
          min="0.00"
          placeholder="0.00"
          value="0"
        />
        <div class="gratuity-button-section">
          <button
            class="btn gratuity-button activated"
            name="gratuity-percentage"
            value="0"
          >
            0%
          </button>
          <button
            class="btn gratuity-button"
            name="gratuity-percentage"
            value="10"
          >
            10%
          </button>
          <button
            class="btn gratuity-button"
            name="gratuity-percentage"
            value="15"
          >
            15%
          </button>
          <br />
          <button
            class="btn gratuity-button"
            name="gratuity-percentage"
            value="20"
          >
            20%
          </button>
          <button
            class="btn gratuity-button"
            name="gratuity-percentage"
            value="25"
          >
            25%
          </button>
          <button
            class="btn gratuity-button"
            name="gratuity-percentage"
            value="30"
          >
            30%
          </button>
        </div>
      </section>
      <section name="Totals">
        <app-carttotals ref="cartTotals"></app-carttotals>
      </section>
      <br />
      <div class="checkout-pay">
        <span><i class="fa fa-credit-card"></i>&nbsp; Pay now</span>
      </div>
    </div>
    <selectBranchModal ref="selectBranchModal"></selectBranchModal>
    <creditCardsModal ref="creditCardsModal"></creditCardsModal>
    <app-loaderForm :display="'none'" ref="LoaderForm"></app-loaderForm>
  </div>
</template>
<!-- Scripts -->
<script>
import { view } from "./Checkout.vue.js";
import CartTotals from "@/components/CartTotalsPartial.vue";
import SelectBranchModal from "./SelectBranchModal.vue";
import CreditCardsModal from "./CreditCardsModal.vue";
import LoaderForm from "../../components/LoaderForm.vue";

export default {
  name: "Checkout",
  components: {
    "app-carttotals": CartTotals,
    "app-loaderForm": LoaderForm,
    selectBranchModal: SelectBranchModal,
    creditCardsModal: CreditCardsModal,
  },
  mixins: [view],
  data() {
    return {
      branchData: {},
      cartData: {},
      userData: {},

      selectedDate: "",
      minDate: "",
      maxDate: "",

      paymentProvider: "",
      paymentReference: "",
      branchID: "",
      paymentKey: "",
    };
  },
  computed: {
    isEligible: function () {
      return !(
        !localStorage.branchID ||
        !localStorage.franchiseID ||
        !localStorage.userMembershipID
      );
    },
  },
  created() {
    if (!localStorage.branchID)
      this.$router.push({
        path: "Branch",
        query: {
          franchise: localStorage.franchiseUrlFriendlyOrderName,
          returnUrl: "Checkout",
        },
      });

    if (!localStorage.franchiseID) this.$router.push('Franchise');

    if (!localStorage.userMembershipID)
      this.$router.push({ path: 'Login', query: { returnUrl: 'Checkout' } });
  },
  mounted() {
    var _self = this;

    if (this.isEligible) {
      var parameters = {
        Guid: localStorage.cartGuid,
        FranchiseID: localStorage.franchiseID,
        BranchID: localStorage.branchID,
        MembershipUserID: localStorage.userMembershipID,
      };
      _self.$ooApi.orders.checkout
        .v1(parameters)
        .then(function (response) {
          _self.branchData = response.data.branch;
          _self.cartData = response.data.cart;
          _self.userData = response.data.user;
        })
        .then(function () {
          _self.getDistance();
          _self.initializeDatePicker();
          _self.$refs.cartTotals.populate(_self.cartData);

          if (!_self.$tableNo && !_self.$isTab) {
            document
              .querySelector("section[name=Profile] .badge")
              .addEventListener("click", _self.showProfile);
            document
              .querySelector(
                "div[name=ProfileUpdateContainer] input, div[name=ProfileUpdateContainer] textarea"
              )
              .addEventListener("blur", _self.updateLocation);
            document
              .querySelectorAll("button.deliver-option")
              .forEach((item) => {
                item.addEventListener("click", _self.deliver);
              });
          } else {
            document.querySelector("div.checkout-pay").style.display = "block";
            document
              .querySelector("div.checkout-pay")
              .addEventListener("click", _self.pay);
          }

          document
            .querySelector("section[name=Branch] .badge")
            .addEventListener("click", _self.showBranches);
          document
            .querySelector("section[name=Gratuity] input[type=number]")
            .addEventListener("keyup", _self.cartTotalChange);
          document
            .querySelector("section[name=Gratuity] input[type=number]")
            .addEventListener("change", _self.cartTotalChange);
          document
            .querySelector("input[name=order-scheduled-date-picker]")
            .addEventListener("click", _self.changeScheduledDate);
          document
            .querySelectorAll("button[name=order-time]")
            .forEach((item) => {
              item.addEventListener("click", _self.scheduleOrder);
            });
          document
            .querySelectorAll("button[name=gratuity-percentage]")
            .forEach((item) => {
              item.addEventListener("click", _self.selectGratuityPercentage);
            });
        });
    }
  },
};
</script>
<style scoped>
@import "./Checkout.vue.css";
</style>
